// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3kmew","title":"Header_title__UDYzQ","left":"Header_left__2LK7w","clinicName":"Header_clinicName__3Ifad"};